import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var StatsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function StatsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get access logs list for given query params
     *
     * @since 1.0.0
     * @param lite If true, get only few stats (for homepage)
     */
    StatsService.prototype.get = function (lite) {
        return this.apiService.apiCall('GET', 'stats', { lite: lite });
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    StatsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'stats/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    StatsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StatsService_Factory() { return new StatsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: StatsService, providedIn: "root" });
    return StatsService;
}());
export { StatsService };
